import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { QUERY_KEYS, STALE_TIME } from '@/libs/constants'
import type { DailyNote, DailyNotesParams, HookParams } from '@/libs/interfaces'
import { dailyNotesApi } from '@/services/api'

export function useDailyNotes({ params, enabled }: HookParams<DailyNotesParams>) {
  return useQuery<DailyNote[]>({
    queryKey: QUERY_KEYS.dailyNote.list(params),
    enabled: enabled ?? true,
    queryFn: async () => {
      return await dailyNotesApi.getDailyNotes(params)
    },
    placeholderData: (previousData) => previousData,
    staleTime: STALE_TIME['1Hour'], // 1 hour
  })
}

export function useDailyNotesCreateOrUpdate() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: dailyNotesApi.createOrUpdateDailyNotes,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.dailyNote.all,
      })
    },
    onError: () => {
      toast.error(t('common.error'))
    },
  })
}
